import {BidSummary} from "@/src/components/bid/bidding_model";
import {FolderView} from "../files/files";

export interface BaseScopeReference {
    // indexers
    _id: string;
    number: number;
    title: string;
}


export interface BaseScopeModel {
    // indexers
    id: string;
    project_id: string;
    number: number;
    title: string;
    description: string;
    open: boolean;

}


export interface FullScopeModel extends BaseScopeModel {
    // indexers
    // id: string;
    // project_id: string;
    // number: number;
    // title: string;
    // description: string;
    created_by: any;
    root?: FolderView;

}


export interface DeveloperScopeCardModel extends BaseScopeModel {
    num_bidders: number;
    num_bids: number;
    lowest_bid: BidSummary;

}

export function blankScope(){
    return {
        title:"",
        description: "",
    }
}